import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { HttpService } from '../../services/http.service';

@Component({
  selector: 'app-vision-valeurs',
  templateUrl: './vision-valeurs.component.html',
  styleUrls: ['./vision-valeurs.component.scss']
})
export class VisionValeursComponent implements OnInit {

  constructor(private httpService: HttpService,) { }

  ngOnInit(): void {
    //this.news();
  }

  async news() {
    const { value: email } = await Swal.fire({
      title: 'Inscription à la Newsletter',
      input: 'email',
      inputLabel: 'Abonnez vous à notre liste de difusion',
      inputPlaceholder: 'Saisissez votre adresse e-mail',
      confirmButtonText:
        'Soumettre',
      allowOutsideClick: false,
      showCloseButton: true
    })
    if (email) {
      this.httpService.subscribeNewsletter(email).subscribe(
        (response: any) => {
          if (response.status == "success") {
            Swal.fire({
              icon: 'success',
              title: 'Excellent!',
              text: 'Vous serais désormains informé des nouveautés sur nos produits & services.',
            });

          }
        },
        (error) => {
          console.log(error);
          if (error.error.message && error.error.message == 'EMAIL_ALREADY_EXISTE') {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Vous avez déjà souscrit à la newsletter.',
            })
          } else {

            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Vérifier votre connexion puis réessayée.',
            })
          }
        }
      );
    }

  }
}
